import React, { Dispatch } from 'react';

export const RESET_STATE = 'RESET_STATE';
export const IS_LOGGED_IN = 'IS_LOGGED_IN';
export const IS_LOADING = 'IS_LOADING';
export const SET_USER = 'SET_USER';
export const SET_SESSION = 'SET_SESSION';
export const SET_USER_ROLE = 'SET_USER_ROLE';
export const SET_SELECTED_LOCATION = 'SET_SELECTED_LOCATION';
export const SET_SELECTED_PROJECT = 'SET_SELECTED_PROJECT';
export const SET_SELECTED_PARENT_ID = 'SET_SELECTED_PARENT_ID';
export const SET_PROJECTS = 'SET_PROJECTS';
export const SET_LABELS = 'SET_LABELS';
export const SET_AUTH_ERROR = 'SET_AUTH_ERROR';
export const SET_RESET_SUCCESS = 'SET_RESET_SUCCESS';


// export const SET_OPEN_AUDIT_LOG = 'SET_OPEN_AUDIT_LOG';



/** Generates a unique id every time it's called */
function* generateUniqueId() {
  let uniqueId = 0;
  while (true) {
    yield uniqueId++;
  }
}

const uniqueIdForReportsGenerator = generateUniqueId();



export const INITIAL_APP_STATE = {
  login: true,
  loading: false,
  userDetails: {},
  userSession: {},
  userRole: undefined,
  selectedLocationId: -1,
  projects: [],
  selectedProjectId: -1,
  selectedParentId: -1,
  openAuditlog: false,
  labels: [],
  AuthError: null,
  resetSuccess: false,
};

export const appReducer = (state, action) => {
  switch (action.type) {
    case IS_LOGGED_IN:
      return { ...state, login: action.login };
    case SET_USER:
      return { ...state, userDetails: action.userDetails };
    case SET_USER_ROLE:
      return { ...state, userRole: action.userRole };
    case SET_SELECTED_LOCATION:
      return { ...state, selectedLocationId: action.selectedLocationId, selectedProjectId: action.selectedProjectId };
    case SET_LABELS:
      return { ...state, labels: action.labels };
    case SET_PROJECTS:
      return { ...state, projects: action.projects };
    case SET_SELECTED_PROJECT:
      return { ...state, selectedProjectId: action.selectedProjectId };
    case SET_SELECTED_PARENT_ID:
      return { ...state, selectedParentId: action.selectedParentId };
    // case SET_OPEN_AUDIT_LOG:
    //   return { ...state, openAuditlog: !state.openAuditlog };
    case SET_SESSION:
      return { ...state, userSession: action.userSession };
    case IS_LOADING:
      return { ...state, loading: action.loading };
    case SET_AUTH_ERROR:
      return { ...state, AuthError: action.error };
    case SET_RESET_SUCCESS:
      return { ...state, resetSuccess: action.payload };
    case RESET_STATE:
      return INITIAL_APP_STATE;
    default:
      return INITIAL_APP_STATE;
  }
};

export const AppContext = React.createContext(INITIAL_APP_STATE);
